import AccommodationFacilityIcon from './AccommodationFacilityIcon';

const AccommodationFacilityItem = props => {

    const { facility } = props;

    if (!facility) {
        return null;
    }

    return (
        <div key={facility.keyword} className='margin-bottom-large breakInsideAvoid'>
            <strong className='facility-title semi-bold block margin-bottom-half font-16'>
                <AccommodationFacilityIcon keyword={facility.keyword} />
                {facility.name}
            </strong>
            {facility.items.map(facilityItem => (
                <div key={facilityItem.name} className="facility-detail before-checkmark margin-bottom-half">

                    {facilityItem.name}

                    {!!facilityItem.isAdditionalCharge && <span className='gray-tag small-tag margin-start-light'> هزینه جداگانه </span>}

                    {!!facilityItem.isFree && <span className='small-tag green-tag margin-start-light'> رایگان </span>}

                    {!!facilityItem.description && <p className='margin-top-light'>
                        ({facilityItem.description})
                    </p>}

                </div>
            ))}

        </div>
    )
}

export default AccommodationFacilityItem;